import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogIn, LogOut, LayoutDashboard, Truck, Menu, X } from 'lucide-react';

export default function Navbar() {
  const { user, role, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Tutup drawer setiap pindah halaman
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const navLinks = [
    { to: '/monitoring', label: 'Monitoring' },
    { to: '/pengkurban', label: 'Pengkurban' },
  ];

  const linkBase = {
    padding: '6px 14px', borderRadius: 8, textDecoration: 'none',
    fontSize: 14, fontWeight: 500, color: '#a7d9b8', transition: 'all 0.15s',
  };

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 64, zIndex: 100,
        background: 'rgba(20,83,45,0.97)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', padding: '0 0.75rem',
      }}>

        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 9, textDecoration: 'none', flex: 'none', maxWidth: '60%' }}>
          <img
            src="https://qurma.sitpermata.sch.id/img/icon_qurma.png"
            alt="Logo"
            style={{ width: 70, objectFit: 'contain', flexShrink: 0 }}
          />
          <div style={{ minWidth: 0 }}>
            <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, lineHeight: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              Qurma Digital
            </div>
            <div style={{ color: '#86efac', fontSize: 10, whiteSpace: 'nowrap' }}>
              Sistem Monitoring Qurban
            </div>
          </div>
        </Link>

        {/* Desktop nav tengah */}
        <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {navLinks.map(({ to, label }) => (
            <NavLink key={to} to={to}
              style={({ isActive }) => ({ ...linkBase, ...(isActive ? { color: '#fff', background: 'rgba(255,255,255,0.12)' } : {}) })}>
              {label}
            </NavLink>
          ))}
          {user && role === 'admin' && (
            <NavLink to="/admin"
              style={({ isActive }) => ({ ...linkBase, color: isActive ? '#fff' : '#fbbf24', ...(isActive ? { background: 'rgba(251,191,36,0.15)' } : {}) })}>
              <LayoutDashboard size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />Dashboard
            </NavLink>
          )}
          {user && role === 'courier' && (
            <NavLink to="/kurir"
              style={({ isActive }) => ({ ...linkBase, color: '#fbbf24', ...(isActive ? { color: '#fff', background: 'rgba(255,255,255,0.12)' } : {}) })}>
              <Truck size={13} style={{ verticalAlign: 'middle', marginRight: 4 }} />Kurir
            </NavLink>
          )}
        </div>

        {/* Desktop kanan */}
        <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {user ? (
            <button onClick={handleLogout}
              style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', padding: '7px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', gap: 5 }}>
              <LogOut size={13} /> Keluar
            </button>
          ) : (
            <>
              <Link to="/courier-login"
                style={{ background: 'rgba(255,255,255,0.08)', color: '#a7d9b8', border: '1px solid rgba(255,255,255,0.15)', padding: '7px 12px', borderRadius: 8, textDecoration: 'none', fontSize: 13, display: 'flex', alignItems: 'center', gap: 5 }}>
                <Truck size={12} /> Kurir
              </Link>
              <Link to="/login"
                style={{ background: '#fbbf24', color: '#000', padding: '7px 12px', borderRadius: 8, textDecoration: 'none', fontWeight: 700, fontSize: 13, display: 'flex', alignItems: 'center', gap: 5 }}>
                <LogIn size={12} /> Admin
              </Link>
            </>
          )}
        </div>

        {/* Hamburger — hanya mobile */}
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen(o => !o)}
          style={{ display: 'none', background: 'none', border: 'none', cursor: 'pointer', color: '#fff', padding: 6, borderRadius: 8, flexShrink: 0 }}
          aria-label="Buka menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* ── Mobile Drawer ── */}
      {menuOpen && (
        <>
          {/* Overlay gelap di belakang drawer */}
          <div
            onClick={() => setMenuOpen(false)}
            style={{ position: 'fixed', top: 64, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.55)', zIndex: 98 }}
          />

          {/* Drawer panel */}
          {/* PENTING: stopPropagation agar klik di dalam drawer tidak menutupnya */}
          <div
            onClick={e => e.stopPropagation()}
            style={{
              position: 'fixed', top: 64, left: 0, bottom: 0, width: '80%', maxWidth: 300,
              background: '#14532d', zIndex: 99,
              padding: '1rem', display: 'flex', flexDirection: 'column', gap: 4,
              boxShadow: '4px 0 24px rgba(0,0,0,0.35)',
              overflowY: 'auto',
            }}
          >
            {/* Label seksi */}
            <div style={{ fontSize: 11, color: '#5a9a6e', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', padding: '4px 8px', marginBottom: 2 }}>
              Menu
            </div>

            {/* Nav links publik */}
            {navLinks.map(({ to, label }) => (
              <NavLink key={to} to={to}
                style={({ isActive }) => ({
                  display: 'block', padding: '11px 14px', borderRadius: 10,
                  textDecoration: 'none', fontSize: 15, fontWeight: 500,
                  color: isActive ? '#fff' : '#a7d9b8',
                  background: isActive ? 'rgba(255,255,255,0.1)' : 'transparent',
                })}>
                {label}
              </NavLink>
            ))}

            {/* Link admin jika login sebagai admin */}
            {user && role === 'admin' && (
              <NavLink to="/admin"
                style={({ isActive }) => ({
                  display: 'block', padding: '11px 14px', borderRadius: 10,
                  textDecoration: 'none', fontSize: 15, fontWeight: 500,
                  color: isActive ? '#fff' : '#fbbf24',
                  background: isActive ? 'rgba(251,191,36,0.15)' : 'transparent',
                })}>
                🗂 Dashboard Admin
              </NavLink>
            )}

            {/* Link kurir jika login sebagai kurir */}
            {user && role === 'courier' && (
              <NavLink to="/kurir"
                style={({ isActive }) => ({
                  display: 'block', padding: '11px 14px', borderRadius: 10,
                  textDecoration: 'none', fontSize: 15, fontWeight: 500,
                  color: isActive ? '#fff' : '#fbbf24',
                  background: isActive ? 'rgba(251,191,36,0.15)' : 'transparent',
                })}>
                🚚 Portal Kurir
              </NavLink>
            )}

            {/* Spacer */}
            <div style={{ flex: 1 }} />

            {/* Divider */}
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginBottom: 8 }} />

            {/* Tombol login / logout */}
            {user ? (
              <button
                onClick={handleLogout}
                style={{
                  width: '100%', padding: '12px', borderRadius: 10, border: 'none',
                  background: '#dc2626', color: '#fff', fontWeight: 700,
                  fontSize: 14, cursor: 'pointer', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', gap: 6,
                }}>
                <LogOut size={15} /> Keluar
              </button>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {/* Login Kurir */}
                <Link
                  to="/courier-login"
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    padding: '12px', borderRadius: 10, textDecoration: 'none',
                    background: 'rgba(255,255,255,0.08)', color: '#a7d9b8',
                    border: '1px solid rgba(255,255,255,0.2)', fontSize: 14, fontWeight: 600,
                  }}>
                  <Truck size={15} /> Login Kurir
                </Link>

                {/* Login Admin */}
                <Link
                  to="/login"
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                    padding: '12px', borderRadius: 10, textDecoration: 'none',
                    background: '#fbbf24', color: '#000',
                    fontSize: 14, fontWeight: 700,
                  }}>
                  <LogIn size={15} /> Login Admin
                </Link>
              </div>
            )}
          </div>
        </>
      )}

      <style>{`
        @media (max-width: 768px) {
          .hamburger-btn { display: flex !important; align-items: center; }
          .desktop-nav { display: none !important; }
        }
      `}</style>
    </>
  );
}
